import React from 'react'

const Header = () => {
    return (
        <div>
            <header className='w-full bg-gray-900 px-6'>
                <div className='container mx-auto py-6 flex flex-wrap justify-center items-center text-gray-100'>
                    Manage Your Own Civilization!
                </div>
            </header>
        </div>
    )
}

export default Header